module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("uslug");

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (md, options) {
  options = _extends({
    toc: true,
    tocClassName: 'markdownIt-TOC',
    tocFirstLevel: 1,
    tocLastLevel: 6,
    anchorLink: true,
    anchorLinkSymbol: '#',
    anchorLinkBefore: true,
    anchorClassName: 'markdownIt-Anchor',
    resetIds: true,
    indentation: '  ',
    anchorLinkSpace: true,
    anchorLinkSymbolClassName: null,
    uiRouterLinks: false
  }, options);

  let gstate;

  // reset keys id for each instance
  headingIds = {};

  md.core.ruler.push('grab_state_and_token', function (state) {
    gstate = state;
    Token = state.Token;
    // reset keys id for each document
    if (options.resetIds) {
      headingIds = {};
    }
  });

  md.inline.ruler.after('emphasis', 'toc', (state, silent) => {
    let token;
    let match;

    while (state.src.indexOf('\n') >= 0 && state.src.indexOf('\n') < state.src.indexOf(TOC)) {
      if (state.tokens.slice(-1)[0] && state.tokens.slice(-1)[0].type === 'softbreak') {
        state.src = state.src.split('\n').slice(1).join('\n');
        state.pos = 0;
      } else {
        break;
      }
    }

    if (
    // Reject if the token does not start with [
    state.src.charCodeAt(state.pos) !== 0x5B ||
    // Don’t run any pairs in validation mode
    silent) {
      return false;
    }

    // Detect TOC markdown
    match = TOC_RE.exec(state.src);
    match = !match ? [] : match.filter(m => m);
    if (match.length < 1) {
      return false;
    }

    // Build content
    token = state.push('toc_open', 'toc', 1);
    token.markup = TOC;
    token = state.push('toc_body', '', 0);
    token = state.push('toc_close', 'toc', -1);

    // Update pos so the parser can continue
    var newline = state.src.indexOf('\n');
    if (newline !== -1) {
      state.pos = state.pos + newline;
    } else {
      state.pos = state.pos + state.posMax + 1;
    }

    return true;
  });

  const originalHeadingOpen = md.renderer.rules.heading_open;
  md.renderer.rules.heading_open = function (...args) {
    const [tokens, idx,,, self] = args;

    const attrs = tokens[idx].attrs = tokens[idx].attrs || [];
    const anchor = getAnchor(tokens[idx + 1]);
    attrs.push(['id', anchor]);

    if (options.anchorLink) {
      renderAnchorLink(anchor, options, ...args);
    }

    if (originalHeadingOpen) {
      return originalHeadingOpen.apply(this, args);
    } else {
      return self.renderToken(...args);
    }
  };

  md.renderer.rules.toc_open = () => '';
  md.renderer.rules.toc_close = () => '';
  md.renderer.rules.toc_body = () => '';

  if (options.toc) {
    md.renderer.rules.toc_body = function () {
      const headings = [];
      const gtokens = gstate.tokens;

      for (let i = 0; i < gtokens.length; i++) {
        if (gtokens[i].type !== 'heading_close') {
          continue;
        }
        const token = gtokens[i];
        const heading = gtokens[i - 1];
        if (heading.type === 'inline') {
          headings.push({
            level: +token.tag.substr(1, 1),
            anchor: getAnchor(heading),
            content: heading.content
          });
        }
      }

      const tree = { nodes: [] };
      // create an ast
      headings.forEach(heading => {
        if (heading.level < options.tocFirstLevel || heading.level > options.tocLastLevel) {
          return;
        }

        let i = 1;
        let lastItem = tree;
        for (; i < heading.level - options.tocFirstLevel + 1; i++) {
          if (lastItem.nodes.length === 0) {
            lastItem.nodes.push({
              heading: {},
              nodes: []
            });
          }
          lastItem = lastItem.nodes[lastItem.nodes.length - 1];
        }
        lastItem.nodes.push({
          heading: heading,
          nodes: []
        });
      });

      return `\n<ul class="${options.tocClassName}">` + treeToString(tree.nodes, options) + '\n</ul>\n';
    };
  }
};

var _uslug = __webpack_require__(0);

var _uslug2 = _interopRequireDefault(_uslug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let Token = () => {};

var TOC = '[toc]';
var TOC_RE = /^\[toc]$/im;

let headingIds = {};

const repeat = (string, num) => new Array(num + 1).join(string);

const makeSafe = string => {
  var key = (0, _uslug2.default)(string); // slugify
  if (key === '') {
    key = 'a';
  }
  if (!headingIds[key]) {
    headingIds[key] = 0;
  }
  headingIds[key]++;
  return key + (headingIds[key] > 1 ? `-${headingIds[key]}` : '');
};

const getAnchor = token => {
  if (!token._tocAnchor) {
    token._tocAnchor = makeSafe(token.children.reduce((acc, t) => acc + (t.content || ''), ''));
  }

  return token._tocAnchor;
};

const space = () => {
  return _extends({}, new Token('text', '', 0), { content: ' ' });
};

const renderAnchorLinkSymbol = options => {
  if (options.anchorLinkSymbolClassName) {
    return [_extends({}, new Token('span_open', 'span', 1), {
      attrs: [['class', options.anchorLinkSymbolClassName]]
    }), _extends({}, new Token('text', '', 0), {
      content: options.anchorLinkSymbol
    }), new Token('span_close', 'span', -1)];
  } else {
    return [_extends({}, new Token('text', '', 0), {
      content: options.anchorLinkSymbol
    })];
  }
};

const renderAnchorLink = (anchor, options, tokens, idx) => {
  var hrefAttr = 'href';
  var hrefVal = `#${anchor}`;
  if (options.uiRouterLinks) {
    hrefAttr = 'ui-sref';
    hrefVal = `{'#':'${anchor}'}`;
  }
  const linkTokens = [_extends({}, new Token('link_open', 'a', 1), {
    attrs: [['class', options.anchorClassName], [hrefAttr, hrefVal]]
  }), ...renderAnchorLinkSymbol(options), new Token('link_close', 'a', -1)];

  // `push` or `unshift` according to anchorLinkBefore option
  // space is at the opposite side.
  const actionOnArray = {
    false: 'push',
    true: 'unshift'
  };

  // insert space between anchor link and heading ?
  if (options.anchorLinkSpace) {
    linkTokens[actionOnArray[!options.anchorLinkBefore]](space());
  }
  tokens[idx + 1].children[actionOnArray[options.anchorLinkBefore]](...linkTokens);
};

const treeToString = (tree, options, indent = 1) => tree.map(item => {
  let node = `\n${repeat(options.indentation, indent)}<li>`;
  if (item.heading.content) {
    if (!options.uiRouterLinks) {
      node += `\n${repeat(options.indentation, indent + 1)}` + `<a href="#${item.heading.anchor}">${item.heading.content}</a>`;
    } else {
      node += `\n${repeat(options.indentation, indent + 1)}` + `<a ui-sref="{'#':'${item.heading.anchor}'}">${item.heading.content}</a>`;
    }
  }
  if (item.nodes.length) {
    node += `\n${repeat(options.indentation, indent + 1)}` + `<ul>` + treeToString(item.nodes, options, indent + 2) + `\n${repeat(options.indentation, indent + 1)}` + `</ul>`;
  }
  node += `\n${repeat(options.indentation, indent)}</li>`;
  return node;
}).join('');

/***/ })
/******/ ]);